<template>
  <div class="m-3">
    <b-button variant="info" class="mb-3" v-if="podeCriar" @click="novo">
      <i class="fa-solid fa-plus mr-2"></i>
      Inserir
    </b-button>

    <gantt-chart :cols="colunas" :rows="dadosCalculados" @click="editar" />
    <modal ref="modal-cronograma-etapa" @buscar="buscar" />
  </div>
</template>
<script>
import PropostaService from "@/common/services/proposta/proposta.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import cloneDeep from "lodash/cloneDeep";

import GanttChart from "@/components/charts/GanttChart.vue";
import Modal from "./modal.vue";
export default {
  name: "PropostaCronogramaEtapa",
  props: {
    propostaId: {
      required: true,
    },
    propostaOriginalId: {
      required: true,
    },
    duracao: {
      required: true,
    },
    aprovada: {
      type: Boolean,
      default: false,
    },
    endpoint: {
      type: String,
      default: "Proposta",
    },
  },
  components: {
    GanttChart,
    Modal,
  },
  data: () => ({
    dados: [],
  }),
  methods: {
    novo: function () {
      this.$refs["modal-cronograma-etapa"].abrirModal(
        this.duracao,
        this.propostaId,
        this.calcularNumeroEtapa(),
        this.endpoint
      );
    },

    calcularNumeroEtapa: function () {
      if (this.dados == undefined || this.dados == null || this.dados.length == 0) 
        return 1;

      let numeroEtapa = parseInt(this.dados[this.dados.length - 1].etapa.numero) + 1;
      return isNaN(numeroEtapa) ? 1 : numeroEtapa;
    },

    editar: function (item) {
      if (!this.permissao.u) return;

      let form = cloneDeep(item.form);
      form.cronogramaEtapaId = form.id;

      this.$refs["modal-cronograma-etapa"].abrirModal(
        this.duracao,
        this.propostaId,
        null,
        this.endpoint,
        form,
        this.podeExcluir,
        this.podeEditar
      );
    },

    buscar: function () {
      this.$store.dispatch(START_LOADING);
      PropostaService.buscarEtapa(this.propostaOriginalId)
        .then((response) => {
          this.dados = response.data.data.sort((a, b) => a.etapa.numero - b.etapa.numero);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    montar() {
      this.buscar();
    },
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("PropostaCronogramaEtapas");
    },
    podeManipular: function () {
      return !this.aprovada && !this.TelaProponente && !this.TelaProponenteCooperada;
    },
    podeCriar: function () {
      return this.podeManipular && !this.TelaExecAssociada && this.permissao.c;
    },
    podeExcluir: function () {
      return this.podeManipular && !this.TelaExecAssociada && this.permissao.d;
    },
    podeEditar: function () {
      return this.podeManipular && this.permissao.u;
    },
    colunas: function () {
      let colunas = [];
      for (let index = 0; index < this.duracao; index++) {
        colunas.push({
          key: index + 1,
          title: `Mês ${index + 1}`,
        });
      }

      return colunas;
    },
    dadosCalculados: function () {
      let linhas = [];

      if (this.dados)
        linhas = this.dados.map((el) => {
          let elemento = {
            key: el.id,
            width: el.etapa.mesFinal - (el.etapa.mesInicial - 1),
            left: el.etapa.mesInicial - 1,
            title: el.etapa.tituloDaEtapa,
            number: el.etapa.numero,
            form: el,
          };

          return elemento;
        });

      return linhas;
    },
    TelaProponente() {
      return this.endpoint == "PropostaEmpresaProponente";
    },
    TelaExecAssociada() {
      return this.endpoint == "PropostaEmpresaExecutora";
    },
    TelaProponenteCooperada() {
      return this.endpoint == "PropostaEmpresaCooperada";
    },
  },
};
</script>
<style lang=""></style>
